import React from 'react';
import { TabsView } from '@fiverr-private/personalized_content';
import { Container } from '@fiverr-private/layout_components';
import { stepMetaMap, onImpression } from '@fiverr-private/store_builder_bi_events';
import { useImpressionContainer, useImpressionItem } from '@fiverr-private/impressionable';
import { ElementType } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { TabbedCarouselTabClickData } from '@fiverr-private/personalized_content/dist/esm/src/PersonalizedContent/components/TabsView/types';
import { useInitialProps } from '../../hooks/useInitialProps';
import { appTranslate } from '../../i18n';
import { useWizardNavigation } from '../../hooks/use-wizard-navigation/useWizardNavigation';
import { reportClickEvent } from '../../utils/report-bi-event/reportClickEvent';

const PAGE_NAME = 'store_builder_page';

export const AdditionalServices: React.FC = () => {
    const { pageCtxId, userId } = getContext();
    const { currentPath } = useWizardNavigation();
    const { additionalServicesData } = useInitialProps();
    const { sectionNames = [], data = {} } = additionalServicesData;
    const [pageImpressionRef, pageImpressionId] = useImpressionContainer();

    useImpressionItem({
        selfRef: pageImpressionRef,
        selfId: pageImpressionId,
        sendImpressionToBQ: false,
        enrichment: {
            eventType: stepMetaMap[currentPath].impressionName,
            componentName: stepMetaMap[currentPath].name,
        },
        intersectionThreshold: 0,
        onImpression,
    });

    const reportTabClick = (data: TabbedCarouselTabClickData) => {
        reportClickEvent({
            biEventData: {
                userId,
                ctxId: pageCtxId,
            },
            eventType: 'clicked_on_gigs_type_header',
            elementType: ElementType.TAB,
            currentPath,
            tabbedCarouselTabClickData: data,
        });
    };

    return (
        <Container width="100%" ref={pageImpressionRef}>
            <TabsView
                title={appTranslate('steps.additional_services.title')}
                subtitle={appTranslate('steps.additional_services.description') as string}
                sectionNames={sectionNames}
                personalizedContent={data}
                recommendationsParams={{
                    funnelName: PAGE_NAME,
                    pageName: PAGE_NAME,
                }}
                appName={PAGE_NAME}
                perseusName={PAGE_NAME}
                shouldFetchCollections
                mobileView={true}
                reportTabClick={reportTabClick}
                features={{
                    gigInNewTab: true,
                }}
            />
        </Container>
    );
};

AdditionalServices.displayName = 'AdditionalServices';
